import { useEffect, useRef, useState } from 'react'
import { i18n } from '../../utils/translates/i18n'
import { toast } from 'react-toastify'
import { createGamePackage, doEditGamePackage } from '../../services/LotteriesService'

export default function ModalGamePackage({ editGamePackage, doGetGamePackages }) {
  const token = sessionStorage.getItem('token')
  const btnClose = useRef('')

  const DEFAULT_POST = {
    id: '',
    mainLotteryId: '',
    qty: 10,
    multiplier: 1000,
    maxValue: 50,
    limitRepeat: 0,
  }
  const [post, setPost] = useState(DEFAULT_POST)

  const saveGamePackage = async () => {
    if (post.id) {
      const success = await doEditGamePackage(token, post)
      if (success.status) {
        toast.success(i18n.t('lottery_updated'))
        doGetGamePackages(success.editedGamePackage?.mainLotteryId)
        btnClose.current.click()
      }
    } else {
      const success = await createGamePackage(token, post)
      if (success.status) {
        toast.success(i18n.t('lottery_created'))
        doGetGamePackages(success.newGamePackage?.mainLotteryId)
        btnClose.current.click()
      }
    }
  }

  useEffect(() => {
    setPost(DEFAULT_POST)
    if (editGamePackage.mainLotteryId) {
      setPost(editGamePackage)
    }
  }, [editGamePackage])

  return (
    <div
      className="modal fade"
      id="modalGamePackage"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalTitleNotify"
      aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title" id="modalTitleNotify">
              {post.id
                ? `${i18n.t('edit')} ${i18n.t('award_packages')}`
                : `${i18n.t('create')} ${i18n.t('award_packages')}`}
            </p>
            <button
              ref={btnClose}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="close"></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6 mb-2">
                <div className="input-group">
                  <div className="btn bg-dark text-light">{i18n.t('qty')}</div>
                  <input
                    type="number"
                    min={0}
                    step={1}
                    className="form-control"
                    value={post.qty}
                    onChange={e => setPost({ ...post, qty: e.target.value })}
                  />
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="input-group">
                  <div className="btn bg-dark text-light">{i18n.t('multiplier')} X</div>
                  <input
                    type="number"
                    min={1}
                    step={1}
                    className="form-control"
                    value={post.multiplier}
                    onChange={e => {
                      setPost({
                        ...post,
                        multiplier: e.target.value,
                        maxValue: parseFloat(50000 / e.target.value).toFixed(2),
                      })
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="input-group">
                  <div className="btn bg-dark text-light">{i18n.t('maxValue')}</div>
                  <input
                    type="number"
                    min={0}
                    step={1}
                    className="form-control"
                    value={post.maxValue}
                    onChange={e => setPost({ ...post, maxValue: e.target.value })}
                  />
                </div>
              </div>
              <div className="col-lg-6 mb-2">
                <div className="input-group">
                  <div className="btn bg-dark text-light">{i18n.t('limitRepeat')}</div>
                  <input
                    type="number"
                    min={0}
                    step={1}
                    className="form-control"
                    value={post.limitRepeat}
                    onChange={e => setPost({ ...post, limitRepeat: e.target.value })}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-success" type="button" onClick={saveGamePackage}>
                <i className="fa fa-save me-2"></i>
                {i18n.t('save')}
              </button>
              <button className="btn btn-secondary" type="button" onClick={() => btnClose.current.click()}>
                <i className="fa fa-close me-2"></i>
                {i18n.t('doclose')}
              </button>
              {/* <pre>{JSON.stringify(post, null, 2)}</pre> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
